import shared from '@plato/app-shared/i18n/fr.json' with { type: 'json' };
import activityFeed from '../locales/fr/activity-feed.json' with { type: 'json' };
import askPlato from '../locales/fr/ask-plato.json' with { type: 'json' };
import catalog from '../locales/fr/catalog.json' with { type: 'json' };
import common from '../locales/fr/common.json' with { type: 'json' };
import companyAddressTable from '../locales/fr/company-address-table.json' with { type: 'json' };
import companyContactTable from '../locales/fr/company-contact-table.json' with { type: 'json' };
import createCustomerAddressForm from '../locales/fr/create-customer-address-form.json' with { type: 'json' };
import createCustomerContactForm from '../locales/fr/create-customer-contact-form.json' with { type: 'json' };
import customerDetail from '../locales/fr/customer-detail.json' with { type: 'json' };
import customersList from '../locales/fr/customers-list.json' with { type: 'json' };
import dashboard from '../locales/fr/dashboard.json' with { type: 'json' };
import events from '../locales/fr/events.json' with { type: 'json' };
import explorer from '../locales/fr/explorer.json' with { type: 'json' };
import filters from '../locales/fr/filters.json' with { type: 'json' };
import genericList from '../locales/fr/generic-list.json' with { type: 'json' };
import insightsTriage from '../locales/fr/insights-triage.json' with { type: 'json' };
import insights from '../locales/fr/insights.json' with { type: 'json' };
import lineItemTable from '../locales/fr/line-item-table.json' with { type: 'json' };
import notes from '../locales/fr/notes.json' with { type: 'json' };
import opportunities from '../locales/fr/opportunities.json' with { type: 'json' };
import orderLineStatus from '../locales/fr/order-line-status.json' with { type: 'json' };
import orderStatus from '../locales/fr/order-status.json' with { type: 'json' };
import presetDatePicker from '../locales/fr/preset-date-picker.json' with { type: 'json' };
import productDetails from '../locales/fr/product-details.json' with { type: 'json' };
import quotesOrdersActions from '../locales/fr/quotes-orders-actions.json' with { type: 'json' };
import quotesOrdersHeader from '../locales/fr/quotes-orders-header.json' with { type: 'json' };
import quotesOrdersLineActions from '../locales/fr/quotes-orders-line-actions.json' with { type: 'json' };
import quotesOrdersLineItems from '../locales/fr/quotes-orders-line-items.json' with { type: 'json' };
import quotesOrdersList from '../locales/fr/quotes-orders-list.json' with { type: 'json' };
import quotes from '../locales/fr/quotes.json' with { type: 'json' };
import reorders from '../locales/fr/reorders.json' with { type: 'json' };
import salesDraft from '../locales/fr/sales-draft.json' with { type: 'json' };
import salesHistory from '../locales/fr/sales-history.json' with { type: 'json' };
import tableCommon from '../locales/fr/table-common.json' with { type: 'json' };
import tableProductAvailibity from '../locales/fr/table-product-availibity.json' with { type: 'json' };
import tapiIntegration from '../locales/fr/tapi-integration.json' with { type: 'json' };
import tasks from '../locales/fr/tasks.json' with { type: 'json' };
import team from '../locales/fr/team.json' with { type: 'json' };
import toasts from '../locales/fr/toasts.json' with { type: 'json' };
import transactionDetails from '../locales/fr/transaction-details.json' with { type: 'json' };

export const frTranslations = {
    'activity-feed': activityFeed,
    'ask-plato': askPlato,
    catalog: catalog,
    common: common,
    'company-address-table': companyAddressTable,
    'company-contact-table': companyContactTable,
    'create-customer-address-form': createCustomerAddressForm,
    'create-customer-contact-form': createCustomerContactForm,
    'customer-detail': customerDetail,
    'customers-list': customersList,
    dashboard: dashboard,
    explorer: explorer,
    filters: filters,
    'generic-list': genericList,
    insights: insights,
    'insights-triage': insightsTriage,
    'line-item-table': lineItemTable,
    notes: notes,
    opportunities: opportunities,
    'preset-date-picker': presetDatePicker,
    'product-details': productDetails,
    quotes: quotes,
    'quotes-orders-actions': quotesOrdersActions,
    'quotes-orders-header': quotesOrdersHeader,
    'quotes-orders-line-actions': quotesOrdersLineActions,
    'quotes-orders-line-items': quotesOrdersLineItems,
    'quotes-orders-list': quotesOrdersList,
    reorders: reorders,
    'sales-draft': salesDraft,
    'sales-history': salesHistory,
    shared: shared,
    'table-common': tableCommon,
    'table-product-availibity': tableProductAvailibity,
    'tapi-integration': tapiIntegration,
    tasks: tasks,
    toasts: toasts,
    'transaction-details': transactionDetails,
    events: events,
    'order-line-status': orderLineStatus,
    'order-status': orderStatus,
    team: team,
};
